export const AUDIT_LOG_ACTIONS = {
  DELETED: "deleted",
  REMOVED: "removed",
  CREATED: "created",
  UPDATED: "updated",
  LINKED: "linked",
  ADDED: "added",
  ADDED_TO_OPEN_ITEMS: "added to open items",
} as const;

export type AuditLogAction =
  (typeof AUDIT_LOG_ACTIONS)[keyof typeof AUDIT_LOG_ACTIONS];
